function BagIcon({ size = '24', style = {} }) {
  return (
    <svg
      style={{ ...style }}
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <svg
        id="Layer_1"
        data-name="Layer 1"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 24 24"
      >
        <defs>
          <linearGradient
            id="linear-gradient"
            x1="-2.17"
            y1="34.86"
            x2="28.82"
            y2="-10.4"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0" stopColor="#3a416f" />
            <stop offset="1" stopColor="#141727" />
          </linearGradient>
          <linearGradient
            id="linear-gradient-2"
            x1="8.12"
            y1="20.35"
            x2="17.5"
            y2="6.65"
          />
        </defs>
        <rect className="cls-1" width="24" height="24" style={{ fill: 'none' }} />
        <path
          style={{ fillRule: 'evenodd', fill: 'url(#linear-gradient)' }}
          className="cls-2"
          d="M17.73,6V5.25A5.07,5.07,0,0,0,16.1,1.54a5.82,5.82,0,0,0-7.89,0A5.11,5.11,0,0,0,6.58,5.25V6H1V21a2.93,2.93,0,0,0,.93,2.12A3.32,3.32,0,0,0,4.19,24H20.12a3.32,3.32,0,0,0,2.26-.88A2.89,2.89,0,0,0,23.31,21V6ZM8.17,5.25A3.63,3.63,0,0,1,9.34,2.6,4.15,4.15,0,0,1,15,2.6a3.63,3.63,0,0,1,1.17,2.65V6h-8ZM21.72,21a1.45,1.45,0,0,1-.47,1.06,1.65,1.65,0,0,1-1.13.44H4.19a1.65,1.65,0,0,1-1.13-.44A1.45,1.45,0,0,1,2.59,21V7.5H21.72Z"
        />
        <path
          style={{ fillRule: 'evenodd', fill: 'url(#linear-gradient)' }}
          className="cls-3"
          d="M8.4,15.53l2.39,2.25a1.06,1.06,0,0,0,.26.17,1.06,1.06,0,0,0,.31.05,1,1,0,0,0,.3-.05.78.78,0,0,0,.26-.17l2.39-2.25,2.39-2.25a.69.69,0,0,0,.18-.24.73.73,0,0,0,0-.58.69.69,0,0,0-.18-.24.82.82,0,0,0-.25-.16.85.85,0,0,0-.31-.06.81.81,0,0,0-.56.22l-4.22,4L9.53,14.47A.87.87,0,0,0,9,14.25a.85.85,0,0,0-.57.22.81.81,0,0,0-.17.24.75.75,0,0,0-.06.29.72.72,0,0,0,.06.29A.81.81,0,0,0,8.4,15.53Z"
        />
      </svg>
    </svg>
  );
}

export default BagIcon;
